import React, { PropTypes } from 'react';
import styled, { keyframes } from 'styled-components';
import { NitroText } from 'nitro-components';

const display = keyframes`
  0% {
    transform: scale(0, 0);
  }

  75% {
    opacity: 1;
    transform: scale(1.2, 1.2);
  }

  100% {
    opacity: 1;
    transform: scale(1, 1);
  }
`;

const CarToolTipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  width: 135px;
  height: 90px;
  margin-bottom: 30px;
  padding: 8px 0;
  border-radius: 4px;
  box-shadow: 0 3px 17px 0 rgba(0, 0, 0, 0.15);
  opacity: 0;
  background: ${props => props.theme.color.white};
  border: 1px solid ${props => props.theme.color.white};
  animation: ${display};
  animation-duration: ${props => props.animationDuration}ms;
  animation-timing-function: ease-out;
  animation-delay: ${props => props.animationDelay}ms;
  animation-fill-mode: forwards;

  &::after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    transform: translate(-50%);
    border-color: rgba(255, 255, 255, 0);
    border-top-color: ${props => props.theme.color.white};
    border-width: 8px;
  }
`;

const Slash = styled.span`
  display: inline-block;
  margin: 0 4px;
`;

const CarToolTip = ({ current, total, ...props }) => {
  const plural = current !== 1 ? 's' : '';

  return (
    <CarToolTipWrapper {...props}>
      <span>
        <NitroText
          bold
          size={30}
          variant="primary"
        >
          {current}
        </NitroText>
        <NitroText variant="base3">
          <Slash>/</Slash>
          {total}
        </NitroText>
      </span>
      <NitroText variant="base1" size={1}>{`month${plural}`}</NitroText>
    </CarToolTipWrapper>
  );
};

CarToolTip.propTypes = {
  animationDuration: PropTypes.number,
  animationDelay: PropTypes.number,
  current: PropTypes.number,
  total: PropTypes.number,
};

CarToolTip.defaultProps = {
  animationDuration: 300,
  animationDelay: 0,
};

export default CarToolTip;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ProfileTabs/CarToolTip.js